import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Nav/MainNavbar_2.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/components/Organisms/Nav/MainNavbar_3.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/contexts/AppProviderContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/providers/ClientUIProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollProvider"] */ "/Users/ilias/Github/talnet.co/src/providers/ScrollProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ilias/Github/talnet.co/src/providers/UserProvider.js");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/media.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/gradient-box.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/social-icons.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/newsletter.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/svg-icons.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/sticky.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/navbar.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/loader.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/datagrid.css");
;
import(/* webpackMode: "eager" */ "/Users/ilias/Github/talnet.co/src/styles/avatar-logo.css");
